/**
 * Domains as typed or pasted into the allowed-domains setting.
 *
 * Only splitting and tidying happens here. Whether each piece is a domain is
 * the server's decision (`outpost_core::domains`), and its refusal names the one
 * that is not, which is a better answer than a second, slightly different
 * validator in the browser.
 */
export function parseDomains(input: string): string[] {
  const domains = input
    .split(/[\s,;]+/)
    .map((piece) => piece.trim().replace(/^@+/, '').toLowerCase())
    .filter((piece) => piece.length > 0);
  return [...new Set(domains)];
}
